module.exports = __webpack_public_path__ + "static/media/pinpoint-detail-project.5339712d.svg";